import { Component, TemplateRef, Input, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { Notification } from './notification.model';
import { NotificationCategory } from './notification-category.model';
import { state, style, transition, animate, trigger } from '@angular/animations';
import { NotificationService } from './notification.service';
import { ToastService } from '../../../shared/toast.service';
import { Rail360NotificationService } from './rail360-notification.service';
import { TrackAndTraceService } from '../../../views/track-and-trace/track-and-trace.service';
import { SessionService } from '../../../shared/session.service';
import { SignalRService } from './signal-r.service';
import { Router } from '@angular/router';
import { LeaseService } from '../../../views/lease/lease.service';
import { NotificationEditData } from './notification-edit-data.model';
import { RailcarService } from '../../../views/railcar/railcar.service';
import { BaseRentalService } from '../../../views/base-rental/base-rental.service';
import { ServiceEventService } from '../../../views/service-event/service-event.service';
import { SfhSecurityService } from '@sasser/sfh-shared-security';

const categoryTrackandTraceAlert = 'Track & Trace Alert';
const categoryLeaseRetruns = 'Lease Returns';
const railcarCpDate = 'Railcar CP\'d';
const arrivedAtScrap = 'Approve arrival date at scrap service event.';
const UtilizationCaterogry = 'Utilization Lease';
const arrivedAtDestination = 'Railcar Arrived At Destination';
@Component({
	selector: 'notification-container',
	templateUrl: 'notification-container.component.html',
	animations: [
		trigger('dismissAnimation', [
			state('hide', style(
				{
					opacity: '0'
				})),
			transition('* => *', animate(500))
		]),
		trigger('dismissAnimationHide', [
			state('hide', style(
				{
					display: 'none'
				})),
			transition('* => *', animate(500))
		])
	]
})

export class NotificationContainerComponent {
	@ViewChild('railcarCPdTemplate') templateRailcarCPd: TemplateRef<any>;
	@ViewChild('traceResults') templateTraceResults: TemplateRef<any>;
	@ViewChild('traceResultsWithEditFields') templateWithEditFields: TemplateRef<any>;
	@Input() notificationCategories: NotificationCategory[];
	@Output() closeNotifications = new EventEmitter();
	@Input() nightMode: boolean;
	@Input() groupByCategory: boolean;
	@Input() activeView: boolean;
	public isLoading = false;
	public isRequestRecieverForm = true;
  utilizeLease = 'Railcar Movement Detected for Utilization Lease';
  enRouteToScrap = 'Railcar en route to Scrap.';  
  destinationToStorage: boolean;


	constructor(
		private notificationService: NotificationService,
		private rail360NotificationService: Rail360NotificationService,
		private trackAndTraceService: TrackAndTraceService,
		private hubConnectionService: SignalRService,
		private toastr: ToastService,
		private router: Router,
		private leaseService: LeaseService,
		private railcarService: RailcarService,
		private baseRentalService: BaseRentalService,
		private serviceEventService: ServiceEventService,
		public sfhAuth: SfhSecurityService
	) {}

	showApproveButton(notification: Notification): boolean {
		if(notification.title === railcarCpDate){
			return (this.sfhAuth.isAuthenticated() && this.sfhAuth.hasPermissions('CanApproveRailcarCPd'));
		}
		else if(notification.title === arrivedAtScrap){
			return (this.sfhAuth.isAuthenticated() && this.sfhAuth.hasPermissions('CanApproveArrivedAtScrap'));
		}
		else if (notification.title === this.utilizeLease){
			return (this.sfhAuth.isAuthenticated() && this.sfhAuth.hasPermissions('CanApproveUtilizeRate'));
		} 
		else if (notification.title === this.enRouteToScrap && notification.message.includes("Service event is in Draft mode, Approve To Publish.")){
			return (this.sfhAuth.isAuthenticated() && this.sfhAuth.hasPermissions('CanApproveEnrouteToScrap'));
		}
		else if (notification.title === arrivedAtDestination && notification.dataId == notification?.railcar?.futureStorageLocation?.id){
			return (this.sfhAuth.isAuthenticated() && this.sfhAuth.hasPermissions('ToStorageAlert'));
		}
		else{
			return false;
		}
	}

	showReviewButton(notification: Notification): boolean {
		if(notification.title.includes("ready for review") && notification.category === "Shop Portal"){
			return (this.sfhAuth.isAuthenticated() && this.sfhAuth.hasPermissions('CanApproveShopPortalChanges'));
		}
		else{
			return false;
		}
	}

	getIcon(title: string, errorMessage: string, warningMessage: string): string {
		if (!!errorMessage) {
			return 'fa-exclamation-circle';
		} else if (!!warningMessage) {
			return 'fa-warning';
		}

		var titleLowerCase = title.toLowerCase();
		var value = titleLowerCase.includes('railcar')
			? 'Railcar'
			: titleLowerCase.includes('estimate') || titleLowerCase.includes('invoice')
				? 'Billing'
				: titleLowerCase.includes('lease')
					? 'Lease'
					: titleLowerCase.includes('program')
						? 'Program'
						: titleLowerCase.includes('file')
							? 'File'
							: title;

		switch (value) {
			case 'Track & Trace Alert':
				return 'fa-map-pin';
			case 'Billing':
				return 'fa-dollar';
			case 'Lease':
				return 'fa-handshake';
			case 'Railcar':
				return 'fa-train';
			case 'Program':
				return 'fa-cogs';
			case 'File':
				return 'fa-file';
			default:
				return 'fa-bolt';
		}
	}

	dismissNotification(category: NotificationCategory, item: Notification): void {
		if (item && item.id) {
			this.notificationService.dismissNotification(item.id)?.subscribe(response => {
				item.hideNotification = true;
				item.dismissed = true;
				this.hubConnectionService.removeEmptyCategories();
				item.isLoading = false;
			},
			error => {
				this.toastr.error(error, 'Could not dismiss notification!');
				item.isLoading = false;
			})
		}
	}

	toggleExpandNotification(notification: Notification): void {
		notification.isExpanded = !notification.isExpanded;
		if (notification.isExpanded) {
			this.loadExpandedTemplateData(notification);
		}
	}

	loadExpandedTemplateData(notification: Notification): void {
		notification.templateData = null;
		if (notification.category === categoryTrackandTraceAlert || notification.category == UtilizationCaterogry) {
			if (notification.title === railcarCpDate) {
				this.rail360NotificationService.getRailcarCPdNotificationData(notification).subscribe(result => {
					this.trackAndTraceService.getById(notification.trackAndTraceRequestId).subscribe(tr => {
						const templateData = result;
						templateData.traceResults = this.selectTraceResultsToDisplay(tr.traceResults, [3, 4, 7]);
						notification.templateData = templateData;
					});
				});
      } else if (notification.title === arrivedAtScrap || (notification.title === arrivedAtDestination && notification.dataId == notification?.railcar?.futureStorageLocation?.id)) {
				this.trackAndTraceService.getById(notification.trackAndTraceRequestId).subscribe(tr => {
					const alertIds = [tr.alertType.valueOf()];
					notification.templateData = this.getEditData(notification, tr.traceResults, alertIds);
				});
			} else {
				this.trackAndTraceService.getById(notification.trackAndTraceRequestId).subscribe(tr => {
					const alertIds = [tr.alertType.valueOf()];
					notification.templateData = this.selectTraceResultsToDisplay(tr.traceResults, alertIds);
				});
			}
		}
	}

	private getEditData(notification: Notification , traceResults, alertIds) {
		var value = new NotificationEditData();
		value.data = this.selectTraceResultsToDisplay(traceResults, alertIds);
		value.value = notification.value;
		value.category = notification.category;
		value.notificationId = notification.id;
		if(!!notification.railcar && !!notification.railcar.lease){
			value.lease = notification.railcar.lease
		}
		return value;
	}

	private selectTraceResultsToDisplay(traceResults: any[], alertIds: number[]): any[] {
		var index = -1;
		var filteredTraceResult = traceResults.filter(x => x.alerts.some(a => alertIds.includes(a)));			
		filteredTraceResult.forEach(item => {
			if(traceResults.findIndex(x=>x.id == item.id) > index){
				index = traceResults.findIndex(x=>x.id == item.id);
			}
		});
		if (index < 0) {
			return traceResults.slice(traceResults.length - 6, traceResults.length);
		}

		var subset = traceResults.slice((index > 3) ? index - 3 : 0, (traceResults.length - index > 2) ? index + 3 : traceResults.length);
		subset.forEach(x => {
			if (x.alerts.some(a => alertIds.includes(a))) {
				x.arrived = true;
			}
		});
		return subset;
	}

	getExpandedContent(notification: Notification): TemplateRef<any> | null {
		if (notification.category === categoryTrackandTraceAlert || notification.category == UtilizationCaterogry) {
			if (notification.title === railcarCpDate ) {
				return this.templateRailcarCPd;
			} else if (notification.title === arrivedAtScrap) {
				this.destinationToStorage = false;
				return this.templateWithEditFields;
			} else if (notification.title === arrivedAtDestination && notification.dataId == notification?.railcar?.futureStorageLocation?.id) {
				this.destinationToStorage = true;
				return this.templateWithEditFields;
			} else {
				return this.templateTraceResults;
			}
		} 
		return null;
	}

	valueChanged(event: any): void {
		var notificationCategory = this.notificationCategories.find(x => x.name === event.category);
		var notification = notificationCategory?.notifications.find(x => x.id === event.notificationId);

		if (event.value instanceof Date) {
			if (notification) {
				notification.oldValue = notification.value?.toLocaleDateString("en-US");
				notification.newValue = event.value?.toLocaleDateString("en-US");
			}
		} else {
			if (notification) {
				notification.oldValue = notification.value;
				notification.newValue = event.value;
			}
		}

		if (notification) {
			notification.value = event.value;
			this.loadExpandedTemplateData(notification);
		}
	}

	receiverFormChange(event:boolean){
		this.isRequestRecieverForm = event;
	}

	approve(notification: Notification, category: NotificationCategory): void {
		notification.isLoading = true;
		switch (notification.title) {
			case 'Railcar CP\'d':
				this.leaseService.approveCpDate(notification.value, notification).subscribe(result => {
					this.dismissNotificationToAllUser(category, notification);
					this.toastr.success(notification.railcar.initial + ' ' + notification.railcar.number +
						' has been successfully CP\'d on ' + new Date(notification.value).toLocaleDateString(), 'Approved!');
				},
				error => {
					this.toastr.error(error, 'Could not approve notification!');
					notification.isLoading = false;
				});
				break;
			case arrivedAtScrap:
				this.railcarService.arriveAtShop(notification.railcar.id, notification.value, this.isRequestRecieverForm).subscribe(result => {
					this.dismissNotificationToAllUser(category, notification);
					this.toastr.success(notification.railcar.initial + ' ' + notification.railcar.number +
						' has been successfully updated to arrive on ' + new Date(notification.value).toLocaleDateString(), 'Approved!');
				},error => {
					this.toastr.error(error, 'Could not approve notification!');
					notification.isLoading = false;
				});
				break;
				case arrivedAtDestination:
					this.railcarService.arriveAtStorage(notification.railcar.id, notification.value).subscribe(result => {
						this.dismissNotificationToAllUser(category, notification);
						this.toastr.success(notification.railcar.initial + ' ' + notification.railcar.number +
							' has been successfully updated to arrive on ' + new Date(notification.value).toLocaleDateString(), 'Approved!');
					},error => {
						this.toastr.error(error, 'Could not approve notification!');
						notification.isLoading = false;
					});
					break;
			case this.utilizeLease:
				this.baseRentalService.updateBaseRentalRatesOnApprove(notification.dataId, notification.createdDate).subscribe(result => {
					this.dismissNotificationToAllUser(category, notification);
					this.toastr.success('Upated utilize rate for ' + notification.railcar.initial + ' ' + notification.railcar.number, 'Approved!');
				},error => {
					this.toastr.error(error, 'Could not approve notification!');
					notification.isLoading = false;
				});
				
				break;
			case this.enRouteToScrap:
				this.serviceEventService.getServiceEvent(notification.dataId).subscribe(serviceEvent => {
					if (serviceEvent) {
						let publishRequest
						if (serviceEvent.type.name === 'Scrap') {
							publishRequest = this.serviceEventService.publishScrappingEvent(notification.dataId, false, false);
						} else {
							publishRequest = this.serviceEventService.publishServiceEvent(notification.dataId, false, false);
						}
						publishRequest.subscribe(results => {
							results.forEach(message => {
								if (message.indexOf('Error: Track&Trace') === 0) {
									this.toastr.error(message, 'Track & Trace Error!', {
										timeOut: 20000
									});
								} else if (message.toLowerCase().includes('warning')) {
									this.toastr.warning(message, 'Warning!', {
										timeOut: 15000
									});
								} else if(message.toLowerCase().includes('please contact')) {
									this.toastr.error(message, 'An error occurred!', {
										timeOut: 20000
									});
								} else {
									const messageTitle = results.indexOf(message) === 0 ? 'Publish successful!' : '';
									this.dismissNotificationToAllUser(category, notification);					
									this.toastr.success(message, messageTitle, {
										timeOut: 10000
									});
								}
							});
						},
						(err) => {
							this.toastr.error(err.error.Detail, 'Error publishing service event!');
							notification.isLoading = false;
						});
					}
				});
				break;
			default:
				this.dismissNotificationToAllUser(category, notification);
				break;
		}
	}

	review(notification: Notification): void {
		if(notification.category === "Shop Portal" && notification.title.includes("ready for review")) {
			this.closeNotifications.emit();
			this.router.navigate(['/fleet/shopportal/approvals']);
		} else {
			return;
		}
	}

	navigateToUrl(notification: Notification, category: NotificationCategory): void {
		this.closeNotifications.emit();
		this.router.navigate([notification.navigateUrl],{queryParams: notification.queryParams});
	}

	dismissNotificationToAllUser(category: NotificationCategory, item: Notification): void {
		this.notificationService.dismissNotificationToAllUser(item.notificationId).subscribe(response => {
			item.hideNotification = true;
			item.dismissed = true;			
			this.hubConnectionService.removeEmptyCategories();
			item.isLoading = false;
		},
		error => {
			this.toastr.error(error, 'Could not dismiss notification!');
			item.isLoading = false;
		})
	}
}
